import Swiper from 'swiper'
import { Navigation, Autoplay, A11y, Keyboard } from 'swiper/modules'
import 'swiper/css'

const init = () => {
    document.querySelectorAll('.js-carousel').forEach((root) => {
        const swiperEl = root.querySelector('.swiper')
        const prevEl = root.querySelector('.js-carousel-prev')
        const nextEl = root.querySelector('.js-carousel-next')
        if (!swiperEl) return

        new Swiper(swiperEl, {
            modules: [Navigation, Autoplay, A11y, Keyboard],
            loop: true,
            speed: 600,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            keyboard: { enabled: true },
            navigation: { prevEl, nextEl },
            a11y: {
                prevSlideMessage: 'Föregående bild',
                nextSlideMessage: 'Nästa bild',
            },
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
} else {
    init()
}
